<template>
  <div
    :class="{'gc-navigator-bottom-bar__link--active': active }"
    class="gc-navigator-bottom-bar__link gc-navigator-bottom-bar__link--community"
    @click="clicked()">
    <div class="gc-navigator-bottom-bar__icon">
      <icon-community
        v-if="active"
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon gc-navigator-bottom-bar__link-icon--active"/>
      <icon-community
        v-else
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon gc-navigator-bottom-bar__link-icon--inactive"/>

      <icon-underline/>
    </div>
  </div>
</template>
<script>
import IconCommunity from '../../../root/icons/IconCommunity'
import IconDot from '../../../root/icons/IconDot'
import IconUnderline from '@/components/root/icons/IconUnderline.vue'

export default {
  name: 'NavigatorBottomBarLinkCommunity',
  components: {
    IconUnderline,
    IconDot,
    IconCommunity
  },
  props: {
    active: {
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit('click')
    }
  }
}
</script>
